module.exports = __webpack_public_path__ + "img/fullscreen_arrows.svg";